document.addEventListener('change', function (event) {
  const select = event.target.closest('.hh-card-variant');
  if (!select) return;

  const form = select.closest('.hh-card-product-form');
  if (!form) return;

  const priceSpan   = form.querySelector('.hh-card-price');
  const compareSpan = form.querySelector('.hh-card-compare-price');

  const selectedOption = select.options[select.selectedIndex];
  if (!selectedOption) return;

  const price     = selectedOption.getAttribute('data-price');
  const compareAt = selectedOption.getAttribute('data-compare-at');

  if (priceSpan && price) {
    priceSpan.textContent = price;
  }

  if (compareSpan) {
    if (compareAt && compareAt !== '' && compareAt !== price) {
      compareSpan.textContent = compareAt;
      compareSpan.classList.remove('is-hidden');
    } else {
      compareSpan.classList.add('is-hidden');
    }
  }
});